import { Sparkle } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import Sparkles from "@/components/Sparkles";

const REASONS = [
  "Attention to detail",
  "Reliable and professional",
  "Friendly service",
  "Quality cleaning products",
  "Flexible scheduling",
  "Residential & commercial cleaning",
  "Family-owned business",
  "We treat every space like our own",
];

const WhyChooseUs = () => (
  <section id="why-us" className="dot-pattern relative overflow-hidden bg-[#F9F9F9] py-20 sm:py-24" data-testid="why-choose-section">
    <Sparkles />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        align="center"
        eyebrow="The Glow & Shine Difference"
        title="Why Choose Glow & Shine Sisters?"
      />
      <div className="mx-auto mt-14 grid max-w-4xl gap-5 sm:grid-cols-2">
        {REASONS.map((r, i) => (
          <Reveal key={r} delay={(i % 2) * 0.08}>
            <div
              className="flex items-center gap-4 rounded-2xl border border-[#8E7CC3]/15 bg-white/80 px-6 py-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
              data-testid={`why-item-${i}`}
            >
              <Sparkle className="h-5 w-5 shrink-0 text-[#D4AF37]" fill="currentColor" aria-hidden="true" />
              <span className="text-base font-medium text-[#2C2A35]">{r}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
